import { render, staticRenderFns } from "./p-add-pill.vue?vue&type=template&id=293fb875&scoped=true"
import script from "./p-add-pill.vue?vue&type=script&lang=js"
export * from "./p-add-pill.vue?vue&type=script&lang=js"
import style0 from "./p-add-pill.vue?vue&type=style&index=0&id=293fb875&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293fb875",
  null
  
)

export default component.exports